
import { Vue, Options } from 'vue-class-component'
import { Prop } from 'vue-property-decorator'
import IconNotFound from '@/components/svg/IconNotFound.vue'

@Options({
  components: { IconNotFound },
  name: 'ItemNotFound',
})
export default class ItemNotFound extends Vue {
  @Prop({ type: String }) readonly content!: string
  @Prop({ type: String }) readonly background: string = 'bg-gray-200'
  @Prop({ type: String }) readonly iconColor: string = 'white'

  get backgroundColor() {
    return this.background
  }
}
